// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13BmY","right":"styles_right__1zbUF"};